<template>
	<div class="tooltip-content">
		<div class="percentage">0% - 1%</div>
		<div class="description-color-wrapper">
			<div class="item-label">{{`+ ${clusterAccountsLength} ${t('accounts.patrimony.labels.accounts')}`}}</div>
		</div>
	</div>
</template>

<script setup>
/* i18n */
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

/** props received
@labelHoverIndex {Number} - hover index
@clusterAccountsLength {Object} - info to display in tooltip
*/
const props = defineProps({
	labelHoverIndex: Number,
	clusterAccountsLength: Number
})
</script>

<style lang="scss" scoped>
.tooltip-content {
	min-width: 166px;
	height: auto;
	padding: 16px;
	box-sizing: border-box;

	background-color: var(--secondary-light-4);
	border-radius: 8px;
	box-shadow: var(--box-shadow-2);

	.percentage {
		@include H2-Regular;
		line-height: 36px;

		color: var(--secondary-dark-4);
	}

	.description-color-wrapper {
		width: 100%;
		margin-bottom: 16px;

		display: flex;
		flex-direction: row;
		align-items: center;
		flex-wrap: wrap;

		.item-label {
			width: calc(100% - 24px);

			@include H7-Regular;
			line-height: 16px;
			color: var(--secondary-dark-4);
			white-space: nowrap;
			text-overflow: ellipsis;
			overflow: hidden;
		}
	}

	.amounts-wrapper {
		width: 100%;
		height: auto;

		.amount {
			@include H8-Regular;
			line-height: 13px;
			color: var(--secondary-dark-1);

			cursor: pointer;
		}
	}
}
</style>
